import { Component, Input, OnInit } from '@angular/core';
import { DashboardViewService } from '../shared/services/dashboard-view.service';
import { DeviceModelFactoryService } from '../shared/services/device-model-factory.service';
import { IControlDeviceModel, IControlModel } from '../shared/models/models';
import { DashboardDeviceSummary } from '../shared/models/dashboard-device-summary.interface';

@Component({
    selector: 'dl-dashboard-device',
    styles: [],
    templateUrl: './dashboard-device.component.html'
})
export class DashboardDeviceComponent implements OnInit {
    public static $name: string = 'dashboardDevice';

    @Input() public device: DashboardDeviceSummary;

    constructor(
        private dashboardViewService: DashboardViewService,
        private deviceModelFactory: DeviceModelFactoryService
    ) {
    }

    public ngOnInit() {
        this.initializeControls();
    }

    private initializeControls(): angular.IPromise<void> {
        if (this.device.controls) {
            this.prepareControls();
        } else {
            return this.dashboardViewService.getControlsForDevice(this.device.hardwareItem.id).then(result => {
                if (result === null) {
                    this.device.model = null;
                    return null;
                }
                return this.setControls(result);
            },
                _ => {
                return this.setControls(null);
                });
        }
    }

    private setControls(viewModel: CASLink.Device.Ui.ViewModel.Dashboard.DashboardControlViewWrapper) {
        if (viewModel) {
            this.device.hardwareCategory = viewModel.type;
            this.device.controls = viewModel.control as IControlModel;
            this.prepareControls();
        }
    }

    private prepareControls() {
        const controlDevice: IControlDeviceModel = {
            controls: [this.device.controls],
            descriptor: ''
        };

        this.device.model = this.deviceModelFactory.createDynamic(
            this.device.hardwareCategory,
            controlDevice,
            this.device.hardwareItem.areaId,
            this.device.locationId
        );
    }

}
